import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../service/app.service';
import { Router, NavigationEnd, RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent } from './footer';
import { HeaderComponent } from './header';
import { SidebarComponent } from './sidebar';
import { ThemeCustomizerComponent } from './theme-customizer';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app-layout.html',
    standalone: true,
    imports: [
        NgClass,
        ThemeCustomizerComponent,
        SidebarComponent,
        HeaderComponent,
        RouterOutlet,
        FooterComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppLayout implements OnInit, OnDestroy {
    private readonly service = inject(AppService);
    readonly store = this.service.indexState;

    showTopButton = false;
    currentModule: string = '';

    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
    ) {
        this.currentModule = this.activatedRoute.snapshot?.url[0]?.path || '';
        
    }
    headerClass = '';
    ngOnInit() {
        this.initAnimation();
        this.toggleLoader();
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', () => {});
    }

    initAnimation() {
        this.service.changeAnimation();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.changeAnimation();
            }
        });

        const ele: any = document.querySelector('.animation');
        ele.addEventListener('animationend', () => {
            this.service.changeAnimation('remove');
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
